import { Suspense } from "react";
import { KeepAlive } from "react-activation";
import { useLocation } from "react-router-dom";
import Loader from "../components/loader/Loader";

export default function KeepAliveWrapper({ id, children }) {
  const location = useLocation();
  console.log(id,"iddddd")
  return (
    <KeepAlive
      id={id}
      saveScrollPosition="screen"
      when={location.pathname === window.location.pathname}
    >
      <Suspense
        fallback={
          <div
            style={{
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader/>
          </div>
        }
      >
        {children}
      </Suspense>
    </KeepAlive>
  );
}